import { useQuery } from '@tanstack/react-query';
import { isAxiosError } from 'axios';

import { fetchSftpIntegrationUser } from 'apis/merchant-gateway/pos-integration-service/sftp-integration/api';
import { SftpIntegrationUser } from 'apis/merchant-gateway/pos-integration-service/sftp-integration/types';

type State = {
  data: SftpIntegrationUser | null;
  isError: boolean;
  isLoading: boolean;
  error?: any;
  refresh: () => void;
};

const handleApiErrors = (err: unknown) => {
  if (isAxiosError(err) && err.response?.status === 404) {
    return null;
  }

  throw err;
};

export default function useSftpIntegrationUser(merchantId: string): State {
  const { data, isError, error, refetch, isLoading } = useQuery(
    [`/v1/merchant-admin/merchants/${merchantId}/sftp-credentials`],
    () => fetchSftpIntegrationUser(merchantId).catch(handleApiErrors),
    { refetchOnWindowFocus: false },
  );

  return {
    error,
    isError,
    isLoading,
    data: data || null,
    refresh: refetch,
  };
}
